(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5801],{

/***/ 34592:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up",
      function () {
        return __webpack_require__(40283);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_platform_views_Auth_SignUp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8338);
/* harmony import */ var _src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37672);
/* harmony import */ var _src_redux_Provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66884);




var SignUpPage = function(param) {
    var initialReduxState = param.initialReduxState;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_redux_Provider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Redux */ .Z.Redux, {
        initialReduxState: initialReduxState,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_2__/* .NextHead */ .B, {
                currentPath: "/sign-up",
                title: "Sign Up",
                description: "Sign up to the Demyst Platform and get into production with a custom-configured Data API."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_platform_views_Auth_SignUp__WEBPACK_IMPORTED_MODULE_1__/* .SignUp */ .M, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SignUpPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,8278,9440,5943,8229,7467,8338,9774,2888,179], function() { return __webpack_exec__(34592); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);